// Commercial choices use the saved quote; the current price list is never a fallback.
export const isDealReadonly = deal => !!deal && (!deal.editable || ['locked', 'buy', 'refund', 'cancel'].includes(deal.state));
export const dealDeviceName = device => device && (device.full_name || device.name || device.article) || 'Без нового устройства';
const validDealPrice = value => typeof value === 'number' && Number.isFinite(value) && value > 0;
const dealDiscount = value => {
  if (typeof value !== 'number' && typeof value !== 'string') return 0;
  const amount = Number(value);
  return Number.isFinite(amount) && amount > 0 ? amount : 0;
};
export const availableDealSubsidies = subsidies => (Array.isArray(subsidies) ? subsidies : [])
  .filter(item => item && item.subsidyId != null && dealDiscount(item.subsidyPrice) > 0);
export const allowedDealTypes = deal => ['buyout', 'tradein'].filter(type => deal && Array.isArray(deal.allowedTypes) && deal.allowedTypes.includes(type) && deal.prices && validDealPrice(deal.prices[type]));
export const maxDealOffer = (deal, type, subsidies) => {
  const base = deal && deal.prices && deal.prices[type];
  if (!validDealPrice(base)) return { base: null, discount: 0, total: null };
  const discount = type === 'tradein'
    ? Math.max(0, ...availableDealSubsidies(subsidies).map(item => dealDiscount(item.subsidyPrice)))
    : 0;
  return { base, discount, total: base + discount };
};
export const createDealDraft = (deal, initialContractType = null) => {
  const types = allowedDealTypes(deal);
  return {
    // Never replace an existing commercial choice automatically, even if it became unavailable.
    contractType: deal.contractType || (types.length === 1 ? types[0] : types.includes(initialContractType) ? initialContractType : null),
    // undefined means preserve the server device, including an unknown partner device.
    subsidy: undefined,
  };
};
export const previewDeal = (deal, draft, subsidies) => {
  const type = draft.contractType;
  const base = deal.prices && deal.prices[type];
  if (!validDealPrice(base)) return { base: null, discount: 0, total: null };
  let discount = 0;
  if (type === 'tradein') {
    if (draft.subsidy === undefined && deal.contractType === 'tradein') discount = dealDiscount(deal.sumDiscount);
    else if (draft.subsidy !== null) {
      const selected = availableDealSubsidies(subsidies).find(item => String(item.subsidyId) === String(draft.subsidy));
      discount = selected ? dealDiscount(selected.subsidyPrice) : 0;
    }
  }
  return { base, discount, total: base + discount };
};
export const dealSavePayload = (btag, deal, draft) => {
  const body = { btag, revision: deal.revision, contractType: draft.contractType };
  if (draft.contractType === 'buyout') body.subsidy = null;
  else if (draft.subsidy !== undefined) body.subsidy = draft.subsidy;
  return body;
};
export const agreePayload = (data, deal) => {
  if (!deal) return data;
  const safe = { ...data };
  ['initialContractType', 'contractType', 'subsidy', 'subsidyModel', 'price', 'prices', 'newPrice', 'devicePrice', 'sumDiscount', 'totalSum', 'buying'].forEach(key => delete safe[key]);
  return safe;
};
